export const APP_DEBUG = false;
export const APP_LIVE = true;
export const URL_ORIGIN = APP_DEBUG ? "http://127.0.0.1:8000/" : APP_LIVE ? "https://api.timpre.com/" : "https://api.timpre.com/test/";
export const API_URL = `${URL_ORIGIN}api/`;